import {
  getPublicBlogPost,
  getPublicBlogPosts,
  getPublicPage,
} from "../api/contentApi";
import { queryKeys } from "./queryKeys";

export const publicPageQueryOptions = (slug, language) => ({
  queryKey: queryKeys.publicPage(slug, language),
  queryFn: () => getPublicPage(slug, language),
});

export const publicBlogPostsQueryOptions = (language, options = {}) => ({
  queryKey: queryKeys.publicBlogPosts(language, options),
  queryFn: () => getPublicBlogPosts(language, options),
});

export const publicBlogPostQueryOptions = (id, language) => ({
  queryKey: queryKeys.publicBlogPost(id, language),
  queryFn: () => getPublicBlogPost(id, language),
  enabled: Boolean(id),
});
